import { useState, MouseEvent } from "react";
import { useNavigate } from "react-router-dom";
import lottieAnimation from "../../assets/svg/lottie_Animation.json";

import {
  ModalWrapper,
  ModalContent,
  ButtonsContainer,
  StyledLottie,
  ConfettiHeader,
  AccountInfo,
} from "./ConfettiPage.styles";
import Buttons from "../Button/button.component";
import { colors } from "../../theme/color";

type ConfettiProps = {
  handleCloseCofetti?: (event: MouseEvent<HTMLButtonElement>) => void;
  message?: string;
};

export const ConfettiPage = (props: ConfettiProps) => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    email: "",
  });

  const handleNameChange = (key: string, value: string) => {
    setData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const NavigateToConfettiPage = () => {
    navigate("/");
  };

  return (
    <ModalWrapper>
      <ModalContent>
        <StyledLottie animationData={lottieAnimation} />

        <ConfettiHeader>Thank you!</ConfettiHeader>
        <AccountInfo>
          {props.message || "You've successfully joined the waitlist"}
        </AccountInfo>
        <ButtonsContainer>
          <Buttons
            handleClick={props.handleCloseCofetti}
            label="Close"
            width="98%"
            color={colors.ButtonBackgroundColors.primaryMediumHoverButton}
            cursor="pointer"
            border="30px"
            height="48px"
          />
        </ButtonsContainer>
      </ModalContent>
    </ModalWrapper>
  );
};

export default ConfettiPage;
